import React, {useRef} from 'react'
import PortableText from '../components/portableText'
import AccordionSubSection from './accordion-subSection'
import AccordionLinkFile from './accordion-link-file'
import AccordionVendor from './accordion-vendor'
import AccordionLightbox from './accordion-lightbox'
import AccordionCommon from './accordion-common'
import {isUserInRegion} from '../services/auth'
import {useDispatch, useSelector} from 'react-redux'

const Accordion = ({items, userRegion}) => {

    const dispatch = useDispatch()
    const lastAnchor = useSelector(state => state.lastAnchor)
    const pathname = window.location.pathname

    let filteredItem = items.filter(item => isUserInRegion(userRegion, item.region))

    const onAccordionClick = (index) => {

        // scroll to div
        setTimeout(()=>{
            const _id = 'scrollTo-' + index
            const refEl = document.getElementById(_id)

            // refEl.scrollIntoView()
            const _offsetTop = refEl.offsetTop
            // window.scroll({ top: _offsetTop, behavior: 'smooth' })
            // window.scroll(0, 0)
            window.scroll(0, _offsetTop)
        }, 50)

        // keep pre path
        const button = document.getElementById('button-' + index)
        const expanded = button.getAttribute('aria-expanded')

        const landingPage = ['/site', '/building', '/decor', '/signage']
        if(!landingPage.includes(pathname)) return

        if(expanded == 'true'){
            dispatch({type: 'SET_LAST_ANCHOR', payload: {pathname: window.location.pathname, accordionIndex: index}})
        }
        else{
            dispatch({type: 'SET_LAST_ANCHOR', payload: {pathname: null, accordionIndex: 0}})
        }
    }

    return (
        <div className="accordion accordion-primary" id="accordionExample4">

            {/* {console.log('---> items: ', items)} */}

            {
                filteredItem &&
                filteredItem.map((category, i) => (
                    <div key={i} className="accordion-item" id={"scrollTo-" + i}>
                    {/* // <div key={i} className="accordion-item" id={"scrollTo-" + i} ref={divRefs['divRef' + i]}> */}
                        <h6 className="accordion-header" id={"heading-" + i}>
                            <button id={"button-" + i} className={`accordion-button fw-bold ${!(pathname === lastAnchor.pathname && i === lastAnchor.accordionIndex) && 'collapsed'}`} type="button" data-bs-toggle="collapse" data-bs-target={"#collapse-" + i} aria-expanded={(pathname === lastAnchor.pathname && i === lastAnchor.accordionIndex) ? "true" : "false"} aria-controls={"collapse-" + i} index={i} onClick={() => onAccordionClick(i)} >
                                {category.title}
                            </button>
                        </h6>

                        <div id={"collapse-" + i} className={`accordion-collapse collapse ${(pathname === lastAnchor.pathname && i === lastAnchor.accordionIndex) && 'show'}`} aria-labelledby={"heading-" + i} data-bs-parent="#accordionExample4">
                            <div className="accordion-body">

                                {category._rawDecription && <PortableText blocks={category._rawDecription} />}

                                {
                                    // sub-section
                                    category.subSections.filter(item => item._type === 'subSection').length > 0 && <AccordionSubSection items={category.subSections.filter(item => item._type === 'subSection')} userRegion={userRegion} />
                                }

                                {
                                    // link and file
                                    category.subSections.filter(item => item._type === 'link' || item._type === 'fileComponent').length > 0 && <AccordionLinkFile items={category.subSections.filter(item => item._type === 'link' || item._type === 'fileComponent')}  userRegion={userRegion} />
                                }

                                {/* {
                                    // venderReference
                                    category.subSections.filter(item => item._type === 'vendor').length > 0 && <AccordionVendor items={category.subSections.filter(item => item._type === 'vendor')} />
                                } */}
                                {
                                    // venderReference
                                    category.subSections.filter(item => item._type === 'vendorReference').length > 0 && <AccordionVendor items={category.subSections} userRegion={userRegion} />
                                }

                                {
                                    // lightbox with detail pages
                                    category.subSections.filter(item => item._type === 'lightboxWithDetailPage').length > 0 && <AccordionLightbox items={category.subSections.filter(item => item._type === 'lightboxWithDetailPage')} userRegion={userRegion} />
                                }



                                {/* {
                                    // common section
                                    category.subSections.filter(item => item._type === 'commonSection').length > 0 && <AccordionCommon items={category.subSections.filter(item => item._type === 'commonSection')} />
                                } */}

                                {
                                    // common section
                                    category.subSections.filter(item => item._type === 'commonSection').length > 0 && <AccordionCommon items={category.subSections} userRegion={userRegion} />
                                }

                            </div>
                        </div>
                    </div>
                ))
            }
        </div>
    )
}

export default Accordion


